var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RowItemAligned',{staticClass:"row-item",attrs:{"labels":_vm.batteryStorageLabels,"values":_vm.batteryStorageValues,"editable":true,"last":""},on:{"edit":function($event){return _vm.$emit('edit-component', {
      component: 'BatteryStorageEditComponent',
      location: 'technicalDetailsComponent',
      properties: {
        batteryStorageData: _vm.batteryStorageData,
        deviceUuid: _vm.deviceUuid,
      },
    })}}})}
var staticRenderFns = []

export { render, staticRenderFns }